export const ACCESS_TOKEN = "token";
export const REFRESH_TOKEN = "refreshToken";
export const CURRENT_USER = "userData";
export const CURRENT_USER_PERMISSIONS = "userP";
export const CHATING_USER = "user";
